// extracted by mini-css-extract-plugin
export default {"container":"FormPage_container__8zuA-","loadingContainer":"FormPage_loadingContainer__CKWky","profileLoadingText":"FormPage_profileLoadingText__ieIKS"};